import React from 'react';
import { Truck, RotateCcw, Package, Mail, Phone } from 'lucide-react';

const ShippingReturns = () => {
  return (
    <div className="min-h-screen bg-[#FEFCF9]">
      {/* Hero */}
      <section className="py-14 sm:py-18 lg:py-24 bg-[#F5EFE6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] text-[#C4A265] uppercase font-medium mb-3 sm:mb-4">Policies</p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#3E2723] mb-4 sm:mb-6">Shipping & Returns</h1>
            <div className="w-12 h-px bg-[#C4A265] mx-auto mb-4 sm:mb-6"></div>
            <p className="text-sm sm:text-base lg:text-lg text-[#7A6B5D] leading-relaxed">
              Everything you need to know about how we deliver and our return policy
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">

        {/* Shipping */}
        <div className="mb-14 sm:mb-16">
          <div className="flex items-center space-x-3 mb-6 sm:mb-8">
            <Truck className="w-6 h-6 text-[#C4A265]" />
            <h2 className="text-2xl sm:text-3xl font-serif text-[#3E2723]">Shipping</h2>
          </div>
          <div className="w-10 h-px bg-[#C4A265] mb-6 sm:mb-8"></div>

          <ul className="space-y-4 sm:space-y-5">
            {[
              'We ship to all locations within India.',
              'COD available only for orders under Rs. 5000. Orders exceeding this value must be prepaid.',
              'Behat House Atelier primarily ships orders through reputable logistics providers like Shiprocket and DTDC.',
              'The tracking details and carrier information associated with your order will be provided in your shipment confirmation email/sms/whatsapp.',
              'Orders are usually processed within 3-5 business days.',
              'Due to the dynamic nature of each product, shipping costs may vary based on destination, dimensions, and fragility of your order.',
              'We accept returns only in case of manufacturing defects. However handcrafted products are not always perfect, each piece may vary from another. Human error in manufacturing only adds character to the product.'
            ].map((item, i) => (
              <li key={i} className="flex items-start space-x-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#C4A265] mt-2 flex-shrink-0"></span>
                <p className="text-sm sm:text-base text-[#5C5549] leading-relaxed">{item}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Divider */}
        <div className="border-t border-[#E8DCC8] mb-14 sm:mb-16"></div>

        {/* Return & Exchange */}
        <div className="mb-14 sm:mb-16">
          <div className="flex items-center space-x-3 mb-6 sm:mb-8">
            <RotateCcw className="w-6 h-6 text-[#C4A265]" />
            <h2 className="text-2xl sm:text-3xl font-serif text-[#3E2723]">Return & Exchange</h2>
          </div>
          <div className="w-10 h-px bg-[#C4A265] mb-6 sm:mb-8"></div>

          <ul className="space-y-4 sm:space-y-5">
            {[
              'Items are returnable only if unused and in original packaging.',
              'Custom based/commissioned items cannot be returned.',
              'Return requests must be initiated within 24-48hrs.',
              'Once shipped orders cannot be cancelled.',
              'Customized or commissioned orders cannot be cancelled once the order is confirmed.',
              'Please specify the reason for your return in the email, along with your order details.',
              'All cost of order return needs to be borne by the purchaser (unless the order received is defective). An unboxing video needs to be shared within 24-48hrs of receiving the order.',
              'In case of return customer can opt for either store credit or refund in their bank account.',
              'We will process all the refunds or provide credits within 15 days after the return goods have been received in original condition and packaging.',
              'Products purchased during sale period or discounted pricing, are not eligible for return or exchange.'
            ].map((item, i) => (
              <li key={i} className="flex items-start space-x-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#C4A265] mt-2 flex-shrink-0"></span>
                <p className="text-sm sm:text-base text-[#5C5549] leading-relaxed">{item}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Divider */}
        <div className="border-t border-[#E8DCC8] mb-14 sm:mb-16"></div>

        {/* Contact for Returns */}
        <div className="bg-[#F5EFE6] border border-[#E8DCC8] p-6 sm:p-8">
          <div className="flex items-center space-x-3 mb-4">
            <Package className="w-5 h-5 text-[#C4A265]" />
            <h3 className="text-lg sm:text-xl font-serif text-[#3E2723]">Need to Return an Item?</h3>
          </div>
          <p className="text-sm sm:text-base text-[#5C5549] mb-5 leading-relaxed">
            To return an item, please reach out to us with your order details and reason for return:
          </p>
          <div className="space-y-3">
            <a href="mailto:behat.house@gmail.com" className="flex items-center space-x-3 text-sm sm:text-base text-[#3E2723] hover:text-[#C4A265] transition-colors">
              <Mail className="w-4 h-4 text-[#C4A265]" />
              <span>behat.house@gmail.com</span>
            </a>
            <a href="https://wa.me/918700465253" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-sm sm:text-base text-[#3E2723] hover:text-[#C4A265] transition-colors">
              <Phone className="w-4 h-4 text-[#C4A265]" />
              <span>WhatsApp: +91 87004 65253</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingReturns;
